import React from "react";
import {Delete, translate} from "admin-on-rest";
import {deleteStyle} from "./style";
import VirtualSlipDataList from "./VirtualSlipDataList";
import VirtualSlipEditForm from "./VirtualSlipEditForm";
import VirtualSlipCreateForm from "./VirtualSlipCreateForm";

///////////////////// LIST ALL VIRTUAL SLIPS /////////////////////
export const VirtualSlipCrmList = props => <VirtualSlipDataList {...props} />;

///////////////////// UPDATE VIRTUAL SLIP /////////////////////
export const VirtualSlipCrmEdit = props => <VirtualSlipEditForm {...props} />;

///////////////////// CREATE NEW VIRTUAL SLIP /////////////////////
export const VirtualSlipCrmCreate = props => (
  <VirtualSlipCreateForm {...props} />
);

///////////////////// DELETE VIRTUAL SLIP /////////////////////
const VirtualSlipDeleteTitleBase = ({record, translate}) => (
  <div>
    <span style={deleteStyle.deleteText}>
      {translate("aor.action.delete")}
      {record && " " + record.type + " "}
    </span>
    <span style={deleteStyle.slipType}>
      {translate("resources.virtualSlips.titleEdit")}
    </span>
  </div>
);

const VirtualSlipDeleteTitle = translate(VirtualSlipDeleteTitleBase);

export const VirtualSlipDelete = props => (
  <Delete {...props} title={<VirtualSlipDeleteTitle />} />
);



// WEBPACK FOOTER //
// ./src/containers/CRM/VirtualSlips/index.js